module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generated by IcoMoon.io -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n<path d=\"M6.844 10l-2.884 5h9.072l2.884-5z\"></path>\n<path d=\"M15.506 9l-4.619-8h-5.775l4.619 8z\"></path>\n<path d=\"M4.534 2l-4.534 7.856 2.888 5 4.534-7.856z\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./app/assets/svg/google-drive.svg
// module id = 732
// module chunks = 0